import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {messages} from '~/i18n';
import {StorageManager} from '~/util';

Vue.use(VueI18n);

const locale = StorageManager.getLocale();
export const i18n = new VueI18n({locale, messages});
